import React from 'react'

const Cv = ({values,handleChange,handleErreur}) => {

    if(values.displayCv)
    {
        return (
            <div>
                <div>
                    <input type="file" accept='application/pdf' name="cv" id="cv" onChange={handleChange('cv')}/>
                </div>
                <div>
                    {handleErreur('cv')}
                </div>
            </div>
        )
    }
    else
    {
        return (
            <div className="mt-sm-0 mt-3">J'envoie mon CV à la confirmation de mon inscription</div>
        )
    }
}

export default Cv;
